import { composerSettings } from '@ddc-webplatform/cmsc-modules';
import { LAUNCHDARKLY_CLIENT_ID } from 'constants/global-constants';

const DEFAULT_LOCALE = 'en_US';

const COMPOSER_SETTINGS = composerSettings.getComposerSettings();

const { ldClientId } = COMPOSER_SETTINGS;

export const LD_CLIENT_ID = ldClientId || LAUNCHDARKLY_CLIENT_ID;

export const SITE_ID = COMPOSER_SETTINGS.siteId;

export const LOCALE = COMPOSER_SETTINGS.currentLocale || DEFAULT_LOCALE;

export const CMSC_API = COMPOSER_SETTINGS.cmscAPI;

export const LANGUAGES: string[] = (COMPOSER_SETTINGS as { languages?: string[] }).languages ?? [DEFAULT_LOCALE];